import * as RadixRadioGroup from '@radix-ui/react-radio-group'
import * as styles from './radio.css.ts'

export { Root as RadioGroup } from '@radix-ui/react-radio-group'

type RadioItemProps = Pick<React.ComponentProps<typeof RadixRadioGroup.Item>, 'value' | 'disabled' | 'id'> & {
  label?: string
}

export const RadioItem = ({ label, value, disabled = false, id }: RadioItemProps) => {
  return (
    <div className={styles.radioContainer} data-disabled={disabled}>
      <RadixRadioGroup.Item className={styles.radioInput} value={value} disabled={disabled} id={id}>
        <RadixRadioGroup.Indicator className={styles.radioIndicator} />
      </RadixRadioGroup.Item>
      {label && (
        <label className={styles.radioLabel} htmlFor={id} data-disabled={disabled}>
          {label}
        </label>
      )}
    </div>
  )
}
